/* src/app/rt-components/badge/badge.component.scss */
:host {
  display: inline-block;
}
:host .badge {
  background: #5dade0;
  border: 1px solid #5dade0;
  color: #fff;
  font-size: 0.75rem;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5714286;
  min-width: 20px;
  padding: 1px 6px;
  position: relative;
  text-align: center;
}
:host .badge .arrow {
  border: 6px solid transparent;
  height: 0;
  position: absolute;
  width: 0;
}
:host .badge .arrow.arrow-top {
  border-bottom-color: inherit;
  bottom: 100%;
  left: 50%;
  margin-left: -6px;
}
:host .badge .arrow.arrow-right {
  border-left-color: inherit;
  left: 100%;
  margin-top: -6px;
  top: 50%;
}
:host .badge .arrow.arrow-bottom {
  border-top-color: inherit;
  left: 50%;
  margin-left: -6px;
  top: 100%;
}
:host .badge .arrow.arrow-left {
  border-right-color: inherit;
  margin-top: -6px;
  right: 100%;
  top: 50%;
}
:host .badge.border-radius-badge {
  border-radius: 10px;
}
:host .badge.border-radius-badge .arrow.arrow-right {
  margin-left: -2px;
}
:host .badge.border-radius-badge .arrow.arrow-left {
  margin-right: -2px;
}
:host .badge.success-badge {
  background: #008000;
  border-color: #008000;
}
:host .badge.info-badge {
  background: #00bfff;
  border-color: #00bfff;
}
:host .badge.warning-badge {
  background: #ff8c00;
  border-color: #ff8c00;
}
:host .badge.danger-badge {
  background: #dc143c;
  border-color: #dc143c;
}
:host .badge.outline-badge {
  background: none !important;
  color: inherit;
}
:host .badge.outline-badge.success-badge {
  color: #008000;
}
:host .badge.outline-badge.info-badge {
  color: #00bfff;
}
:host .badge.outline-badge.warning-badge {
  color: #ff8c00;
}
:host .badge.outline-badge.danger-badge {
  color: #dc143c;
}
:host .badge.custom-badge:not(.outline-badge) {
  color: #000 !important;
}
:host .badge.arrow-right-badge {
  margin-right: 6px;
}
:host .badge.arrow-left-badge {
  margin-left: 6px;
}
:host .badge.large-badge {
  padding: 6px 20px;
}
:host .badge.large-badge.border-radius-badge {
  border-radius: 15px;
}
:host .badge.medium-badge {
  padding: 3px 12px;
}
:host .badge.medium-badge.border-radius-badge {
  border-radius: 12px;
}
mat-icon :host .badge {
  bottom: 100%;
  left: 100%;
  margin: 0 0 -10px -10px;
  position: absolute;
  z-index: 1;
}
mat-icon :host .badge.top-left {
  left: auto;
  margin: 0 -10px -10px 0;
  right: 100%;
}
mat-icon :host .badge.bottom-left {
  bottom: auto;
  left: auto;
  margin: -10px -10px 0 0;
  right: 100%;
  top: 100%;
}
mat-icon :host .badge.bottom-right {
  bottom: auto;
  margin: -10px 0 0 -10px;
  top: 100%;
}
/*# sourceMappingURL=badge.component.css.map */
